import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export const PERIOD_OPTIONS = [
  ["this_month", "This month"],
  ["last_month", "Last month"],
  ["this_quarter", "This quarter"],
  ["last_quarter", "Last quarter"],
  ["this_year", "This year"],
  ["last_year", "Previous year"],
  ["all", "All time"],
  ["custom", "Custom range"],
];

export const Field = ({ label, children }) => (
  <div className="flex flex-col gap-1">
    <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-500">{label}</span>
    {children}
  </div>
);

export const PeriodPicker = ({ value, onChange, start, end, setStart, setEnd, testid = "period" }) => (
  <>
    <Field label="Period">
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger data-testid={`${testid}-select`} className="h-9 border-slate-300 bg-white">
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="border border-slate-200 bg-white">
          {PERIOD_OPTIONS.map(([v, label]) => (
            <SelectItem key={v} value={v}>
              {label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </Field>
    {value === "custom" && (
      <>
        <Field label="From">
          <Input
            type="date"
            data-testid={`${testid}-start-input`}
            className="h-9 border-slate-300 bg-white"
            value={start}
            onChange={(e) => setStart(e.target.value)}
          />
        </Field>
        <Field label="To">
          <Input
            type="date"
            data-testid={`${testid}-end-input`}
            className="h-9 border-slate-300 bg-white"
            value={end}
            onChange={(e) => setEnd(e.target.value)}
          />
        </Field>
      </>
    )}
  </>
);

export const SummaryCard = ({ label, value, sub, tone, testid }) => (
  <div className="border border-slate-200 bg-white p-5" data-testid={testid}>
    <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-500">{label}</span>
    <div className={`mt-3 font-display text-2xl font-black tracking-tight lg:text-3xl ${tone || ""}`}>
      {value}
    </div>
    {sub && <div className="mt-1 text-xs text-slate-500">{sub}</div>}
  </div>
);
